import SlateEditorContainer from './SlateEditorContainer'
import SlateEditor from './SlateEditor'
export { SlateEditor }
export { SlateEditorContainer }
export default SlateEditorContainer



// WEBPACK FOOTER //
// ./src/components/SlateEditor/index.js